import { useAuth0 } from '@auth0/auth0-react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'
import { Navigate, useLocation } from 'react-router-dom' 
import { useIsVendorFlowCompleted } from 'vendors/queries/useVendorQuery'

const UserFlowCompleted: React.FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation()
  const { user } = useAuth0()

  const { data: isVendorFlowCompleted = false, isError, isLoading } = useIsVendorFlowCompleted(user?.name ?? '')

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (isError) {
    return <Navigate to="/error" replace />
  }

  if (isVendorFlowCompleted === false && !location.pathname.includes('wizard')) {
    return <Navigate to={`/vendors/first/wizard/user`} replace />
  }

  return <>{children}</>
}

export default UserFlowCompleted
